import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commaStringArray',
    standalone: true
})
export class CommaStringArrayPipe implements PipeTransform {
  transform(value: string[]): string {
    let str = '';
    value.forEach((element, index) => {
      str += element;
      if (index < value.length - 1) str += ', ';
    });
    return str;
  }
}
